import React, {useState} from "react";
import "./index.scss";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import {TextField} from "features/components/text-field";
import {func, string} from "prop-types";
import {EmailTextFieldValidator, EmailValidator, RequiredValidator} from "services/utils/validations";
import Select from "features/components/select";
import {PROVINCES} from "constants.js";

const InvoiceForm = (props) => {

    const {name, vat, address, zip, adeCode, pec, province, city, onChange} = props;

    const [nameVal, setName] = useState(name);
    const [vatVal, setVat] = useState(vat);
    const [addressVal, setAddress] = useState(address);
    const [zipVal, setZip] = useState(zip);
    const [adeCodeVal, setAdeCode] = useState(adeCode);
    const [pecVal, setPec] = useState(pec);
    const [provinceVal, setProvince] = useState(province);
    const [cityVal, setCity] = useState(city);

    React.useEffect(() => {
        onChange({
            name: nameVal,
            vat: vatVal,
            address: addressVal,
            zip: zipVal,
            adeCode: adeCodeVal,
            pec: pecVal,
            province: provinceVal,
            city: cityVal,
            valid: RequiredValidator(nameVal) && RequiredValidator(vatVal) && RequiredValidator(addressVal) && RequiredValidator(zipVal) && RequiredValidator(provinceVal) && RequiredValidator(cityVal) && (EmailValidator(pecVal) || RequiredValidator(adeCodeVal))
        });
    }, [onChange, nameVal, vatVal, addressVal, zipVal, adeCodeVal, pecVal, provinceVal, cityVal]);

    return <div className="invoice-form">
        <Title size={18}>{__("forms.invoice.title")}</Title>
        <Text size={16}>{__("forms.invoice.text")}</Text>
        <div className="form-field">
            <TextField
                type={"text"}
                value={nameVal}
                onChange={setName}
                placeholder={__("text-fields.invoice.name.placeholder")}
            />
            <TextField
                type={"text"}
                value={vatVal}
                onChange={setVat}
                placeholder={__("text-fields.invoice.vat-cf.placeholder")}
            />
            <TextField
                type={"text"}
                value={addressVal}
                onChange={setAddress}
                placeholder={__("text-fields.invoice.address.placeholder")}
            />
            <TextField
                type={"text"}
                value={cityVal}
                onChange={setCity}
                placeholder={__("text-fields.invoice.city.placeholder")}
            />
            <div className="row zip-province">
                <TextField
                    type={"text"}
                    value={zipVal}
                    onChange={setZip}
                    placeholder={__("text-fields.invoice.zip.placeholder")}
                />
                <Select
                    value={provinceVal}
                    values={PROVINCES}
                    onChange={setProvince}
                    placeholder={__("text-fields.invoice.province.placeholder")}
                 />
            </div>
            <TextField
                type={"text"}
                value={adeCodeVal}
                onChange={setAdeCode}
                placeholder={__("text-fields.invoice.ade_code.placeholder")}
            />
            <TextField
                type={"text"}
                value={pecVal}
                onChange={setPec}
                placeholder={__("text-fields.invoice.pec.placeholder")}
                validationFunc={EmailTextFieldValidator}
            />
        </div>
        <Text size={14}>{__("forms.invoice.note")}</Text>
    </div>
};

InvoiceForm.propTypes = {
    name: string.isRequired,
    vat: string.isRequired,
    address: string.isRequired,
    zip: string.isRequired,
    adeCode: string.isRequired,
    pec: string.isRequired,
    province: string.isRequired,
    city: string.isRequired,
    onChange: func.isRequired
};

export const InvoiceFormBaseState = {
    name: "",
    vat: "",
    address: "",
    zip: "",
    adeCode: "",
    pec: "",
    province: "",
    city: ""
}

export default InvoiceForm;